import CONSTANTS from "core/constants";

export function getRoles(roles) {
  if (!roles) {
    throw new Error("getRoles was not provided with roles");
  }
  const data = { isAdmin: false, isPsychologist: false };
  roles.forEach((item) => {
    if (item.roleId === CONSTANTS.ROLE_ID.PSYCHOLOGIST) {
      data.isPsychologist = true;
    } else if (item.roleId === CONSTANTS.ROLE_ID.ADMIN) {
      data.isAdmin = true;
    }
  });
  return data;
}

export function hasAnyRole(userRoles, anyOfTheseRoles) {
  return userRoles.some((userRole) => anyOfTheseRoles.includes(userRole));
}
